/**
 * File file-download.js.
 *
 * Custom code to kickstart AJAX functions for file download.
 *
 */
import 'slick-carousel';
import { initPhotoCarousel } from "./image-carousel";
import { initPhoenixTestimonials } from "./phoenix-testimonais";

( function( $ ) {

	// If slick--off is active, we want those styles ONLY to apply at mama and above.
	// For mama and below, we will stll need the slider.
	function initTileSlider() {

		$('.cards--tile-slider.slick--on')?.slick({
			mobileFirst: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			rows: 2,
			slidesPerRow: 1,
			prevArrow: '<button type="button" class="slick-prev"><span class="screen-reader-text">Previous Slides</span></button>',
			nextArrow: '<button type="button" class="slick-next"><span class="screen-reader-text">Next Slides</span></button>',
			dots: true,
			responsive: [
				{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
					rows: 2,
					slidesPerRow: 1,
				}
				},
				{
				breakpoint: 700,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					rows: 2,
					slidesPerRow: 1,
				}
				},
				{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					rows: 2,
					slidesPerRow: 1,
				}
				}
			]
		});

		$('.cards--tile-slider.slick--off')?.slick({
			mobileFirst: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			rows: 2,
			slidesPerRow: 1,
			prevArrow: '<button type="button" class="slick-prev"><span class="screen-reader-text">Previous Slides</span></button>',
			nextArrow: '<button type="button" class="slick-next"><span class="screen-reader-text">Next Slides</span></button>',
			dots: true,
			responsive: [
				{
				breakpoint: 1024,
				settings: "unslick"
				},
				{
				breakpoint: 700,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					rows: 2,
					slidesPerRow: 1,
				}
				},
				{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					rows: 2,
					slidesPerRow: 1,
				}
				}
			]
		});
	}

	initTileSlider();

	$('.block--photo-carousel.display-style--inline .photo-carousel--images')?.each( initPhotoCarousel );

	$('.ftphoenix-slider .wp-block-group__inner-container')?.each( initPhoenixTestimonials );


	const cardCarousel = $('.block--card-carousel .card-carousel');
	if ( cardCarousel ) {

		cardCarousel.each( function(){

			const $this = $(this);
			const appendArrowsContainer = $this.parent().find( '.block--card-carousel--navigation--arrows' );
			const totalCards = $this.data( 'total' );

			const showHideArrows = () => {

				appendArrowsContainer.hide();

				if ( window.innerWidth >= 980 && totalCards > 4 ) {
					appendArrowsContainer.show();
				} else if ( window.innerWidth < 980 && totalCards > 1 ) {
					appendArrowsContainer.show();
				}
			}

			$(window).on( 'resize', showHideArrows );

			showHideArrows();

			$(this).slick({
				mobileFirst: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: '<button type="button" class="slick-prev"><span class="screen-reader-text">Previous Slides</span></button>',
				nextArrow: '<button type="button" class="slick-next"><span class="screen-reader-text">Next Slides</span></button>',
				appendArrows: appendArrowsContainer,
				dots: false,
				responsive: [
					{
						breakpoint: 980,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 4,
						}
					},
					{
						breakpoint: 560,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							centerMode: true,
							centerPadding: '60px',
						}
					}
				]
			});

		});
	}

} )( window.jQuery );
